module.exports = __webpack_public_path__ + "img/main-xl.447673e.webp";